import ResidenceCertificateForm from '@/components/public/services/residence-certificate/ResidenceCertificateForm';
import ServiceRequestLayout from '@/components/public/services/ServiceRequestLayout';

export default function ResidenceCertificate() {
  return (
    <ServiceRequestLayout
      seoTitle="Atestado de Residência"
      seoDescription="Solicite o seu atestado de residência de forma simples. Emitido pela Junta de Freguesia para fins legais, bancários, escolares e administrativos."
      badge="Serviços ao Cidadão"
      breadcrumbs={[{ label: 'Serviços', href: '/services' }, { label: 'Atestado de Residência' }]}
      title="Atestado de Residência."
      accentWord="Residência."
      subtitle="Solicite o seu atestado de residência de forma simples. Emitido pela Junta de Freguesia para fins legais, bancários, escolares e administrativos."
      panelTitle="Pedido de Atestado"
      panelIntro="Preencha o formulário abaixo. Será notificado por email ou telefone quando o documento estiver disponível para levantamento."
    >
      <ResidenceCertificateForm />
    </ServiceRequestLayout>
  );
}
